import numbro from 'numbro'
export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$numbers', { value: numbro })
  }
}
